'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('./styleInject.js');

var css_248z = ".EmailIcon-module_container__-Xv-w{height:auto;vertical-align:middle;width:2rem}";
var styles = {"container":"EmailIcon-module_container__-Xv-w"};
styleInject["default"](css_248z, 'db50e1da-1514-4f35-becf-90182ab4ee57');

exports["default"] = styles;
